import Joi from 'joi';

const emptyString = Joi.string().empty('');

export const imageInteractiveComponentSchema = Joi.object({
    itemList: emptyString,
    mainImage: Joi.object(),
    content: Joi.any().required(),
}).options({ stripUnknown: true });